<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="操作人">
                <a-input v-model="queryParam.updateUser"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="渠道负责人">
                <a-select v-model="queryParam.channelPrincipalId">
                  <a-select-option :title="i.userName" v-for="i in ChannelDirector" :key="i.userId">
                    {{ i.userName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="负责区域">
                <a-input v-model="queryParam.channelArea"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="操作时间">
                <a-range-picker
                  v-model="queryParam2.updateTime"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChange2"
                  @ok="onOk"
                  style="width:100%"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="18"></a-col>
            <a-col :span="6" style="text-align: right">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearValues">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider />
      <a-row>
        <a-col :span="20"></a-col>
        <a-col :span="4" style="text-align: right">
          <a-button v-if="addEnable" type="primary" style="margin-left: 8px;" icon="plus" @click="add()">新增</a-button>
        </a-col>
      </a-row>
      <s-table
        :scroll="{ x: 1300 }"
        style="margin-top: 20px"
        size="default"
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        bordered
      >
        <span slot="action" slot-scope="text, record" style="white-space: nowrap;">
          <a v-if="viewEnable" @click="handleShow(record)">查看</a>
          <a-divider v-if="viewEnable" type="vertical" />
          <span v-if="editAndForbidden">
            <a @click="Edit(record)">编辑</a>
            <a-divider type="vertical" />
            <a v-if="record.disableStatus == 0" @click="showState(record, record.disableStatus)">启用</a>
            <a v-else @click="showState(record, record.disableStatus)">禁用</a>
          </span>
        </span>
        <span slot="action2" slot-scope="text, record" style="white-space: normal;">
          {{ text }}
        </span>
      </s-table>
      <!--弹框model-->
      <a-modal
        :title="Title"
        style="top: 20px;"
        :width="800"
        v-model="addModel"
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
      >
        <a-form :form="form2" :class="status == 1 ? 'readyOnly' : ''">
          <a-row :gutter="24">
            <a-form-item v-if="getSubmit == 1" style="display:none">
              <a-input v-decorator="['channelAreaId']" />
            </a-form-item>
            <a-col :span="18">
              <a-form-item label="区域名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input
                  v-decorator="['districtName', { rules: [{ required: true, message: '此项为必填项' }] }]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="18">
              <a-form-item label="渠道负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  v-decorator="['channelPrincipalIds', { rules: [{ required: true, message: '此项为必填项' }] }]"
                  mode="multiple"
                  :size="size"
                  @change="handleChange"
                  @popupScroll="popupScroll"
                >
                  <a-select-option v-for="i in ChannelDirector" :key="i.userId">
                    {{ i.userName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="18">
              <a-form-item label="负责区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-tree
                  v-model="checkedKeys"
                  checkable
                  :expanded-keys="expandedKeys"
                  :auto-expand-parent="autoExpandParent"
                  :selected-keys="selectedKeys"
                  :tree-data="treeData"
                  @expand="onExpand"
                  @select="onSelect"
                  @check="onCheck"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
    </a-card>
    <no-authority v-if="!queryList"></no-authority>
  </div>
</template>
<script>
import { STable } from '@/components'
import {
  enableChannelArea,
  disableChannelArea,
  ChannelAreaSearch,
  geographyData,
  addChannelArea,
  selectChannelArea,
  editChannelArea
} from '@/api/master/RegionalDivision'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import { findByDeptId } from '@/api/enterprise/user'
import moment from 'moment'
import NoAuthority from '../enterprise/NoAuthority'
import pick from 'lodash.pick'

export default {
  name: 'TableList',
  components: {
    STable,
    NoAuthority
  },
  data() {
    return {
      queryParam2: {},
      addEnable: checkPermission('master:areaList:add'),
      editAndForbidden: checkPermission('master:areaList:editAndForbidden'),
      viewEnable: checkPermission('master:areaList:view'),
      queryList: checkPermission('master:RegionalDivision:query:list'),
      ChannelD: [],
      treeData: [],
      demoStatus: 0,
      Title: '操作',
      expandedKeys: [], //展开指定节点
      autoExpandParent: true,
      checkedKeys: [], //选中区域
      selectedKeys: [],
      form: this.$form.createForm(this),
      addModel: false,
      status: 0,
      labelCol: {
        xs: { span: 4 },
        sm: { span: 12 }
      },
      wrapperCol: {
        xs: { span: 4 },
        sm: { span: 12 }
      },
      confirmLoading: false,
      mdl: {},
      form2: this.$form.createForm(this),
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '20px',
          dataIndex: 'title',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'disableStatus',
          width: '20px',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '区域名称',
          dataIndex: 'areaName',
          width: '100px',
          align: 'center'
        },
        {
          title: '渠道负责人',
          width: '120px',
          dataIndex: 'areaPrincipal',
          align: 'center'
        },
        {
          title: '负责区域',
          dataIndex: 'responArea',
          scopedSlots: { customRender: 'action2' }
        },
        {
          title: '操作时间',
          width: '180px',
          dataIndex: 'updateTime',
          align: 'center'
        },
        {
          title: '操作人',
          width: '20px',
          dataIndex: 'updateUser',
          align: 'center'
        }
      ],
      ChannelDirector: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return ChannelAreaSearch(Object.assign(parameter, this.queryParam))
      }
    }
  },
  filters: {},
  async created() {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    findByDeptId('106').then(res => {
      this.ChannelDirector = res
    })
    geographyData().then(res => {
      this.treeData = res.data
    })
  },
  // destroyed () {
  //   document.body.removeEventListener('keyup', e => {})
  // },
  methods: {
    moment,
    onChange2(value, dateString) {
      this.queryParam.startUpdateTime = dateString[0]
      this.queryParam.endUpdateTime = dateString[1]
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys
    },
    add() {
      //新增
      this.demoStatus = 1
      this.form2.resetFields()
      this.addModel = true
      this.checkedKeys = []
      this.getSubmit = 0
    },
    showState(val, id) {
      if (id == '1') {
        disableChannelArea({ channelAreaId: val.channelAreaId }).then(res => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (id == '0') {
        enableChannelArea({ channelAreaId: val.channelAreaId }).then(res => {
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    handleChange1(value) {
      this.queryParam.importance = value
    },
    clearValues() {
      this.queryParam = {}
      this.queryParam2 = {}
      this.$refs.table.refresh(true)
    },
    onOk1(value) {},
    handleAdd() {
      this.$refs.modal.add()
    },
    Edit(record) {
      //编辑
      this.demoStatus = 2
      this.form2.resetFields()
      selectChannelArea({ channelAreaId: record.channelAreaId }).then(res => {
        console.log(res.data)
        res.data.channelPrincipalIds = res.data.channelPrincipalIds.split(',')
        for (var i = 0; i < res.data.channelPrincipalIds.length; i++) {
          res.data.channelPrincipalIds[i] = Number(res.data.channelPrincipalIds[i])
        }
        this.addModel = true
        this.status = 0
        this.getSubmit = 1
        this.$nextTick(() => {
          this.form2.setFieldsValue(
            pick(res.data, 'channelAreaId', 'channelPrincipalIds', 'districtList', 'districtName')
          )
        })
        this.checkedKeys = res.data.districtList
      })
    },
    handleShow(record) {
      //编辑
      this.demoStatus = 2
      this.form2.resetFields()
      selectChannelArea({ channelAreaId: record.channelAreaId }).then(res => {
        console.log(res.data)
        res.data.channelPrincipalIds = res.data.channelPrincipalIds.split(',')
        for (var i = 0; i < res.data.channelPrincipalIds.length; i++) {
          res.data.channelPrincipalIds[i] = Number(res.data.channelPrincipalIds[i])
        }
        this.addModel = true
        this.status = 1
        this.getSubmit = 1
        this.$nextTick(() => {
          this.form2.setFieldsValue(
            pick(res.data, 'channelAreaId', 'channelPrincipalIds', 'districtList', 'districtName')
          )
        })
        this.checkedKeys = res.data.districtList
      })
    },
    handleOk() {
      this.$refs.table.refresh()
    },
    handleSubmit(e) {
      if (this.checkedKeys.length == 0) {
        return this.$message.error('请选择负责区域')
      }
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          values.districtList = this.checkedKeys
          console.log(this.getSubmit)
          if (this.getSubmit == 0) {
            addChannelArea(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.$refs.table.refresh(true)
                  this.addModel = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else if (this.getSubmit == 1) {
            editChannelArea(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.handleOk()
                  this.addModel = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    }
  },
  watch: {
    // checkedKeys(val) {
    //   console.log('onChecka', val);
    // },
  }
}
</script>

<style scoped>
.twobtn {
  background-color: #409eff;
  color: white;
  width: 110px;
  font-size: 15px;
}
.ant-divider.ant-divider-horizontal {
  margin: 12px 0 !important;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
.readyOnly {
  pointer-events: none;
}
</style>
